module.exports = __webpack_public_path__ + "static/img/visao.dcbc5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/visao.jpg
// module id = Zw58
// module chunks = 1